// @ts-nocheck
import React, { useEffect, useRef, useState } from "react";
import useConcatenatedString from "../../../custom_hooks/useConcatenatedString";
import { useModalContext } from "../../Reactportal/ModalContext";
import { GetTodaysDateINdmy } from "../../../../CommonFunction/GetTodaysDate";
import { useSelector } from "react-redux";
import { gql, useLazyQuery, useMutation } from "@apollo/client";
import { ClearSpecificForm } from "../../../../Store/FormDataReducer/FormFieldFunctions";
import {
  CREATE_LR_DELIVERY,
  EDIT_FTL_CN_DELIVERY,
  EDIT_LR_DELIVERY,
  GET_LRDelivery_BY_ID,
  getFormSectionsAndFields,
} from "../../../../Utils/AllPagesQuriesAndMutations";
import { useDispatch } from "react-redux";
import { convertToISO, IsoToDateWithoutTime } from "../../../../CommonFunction/IsoDateTime";
import { ErrorToast, SuccessToast } from "../../ToastComponent/RectHotToast";
import { useEventListener } from "usehooks-ts";
import Reactportal from "../../Reactportal/Reactportal";
import AddPickupMemoSection from "../AddPickupMemo/AddPickupMemoSection/AddPickupMemoSection";
import DocumentuploadSection from "../../../Templets/DocumentuploadSection/DocumentuploadSection";
import PortalFooter from "../../Reactportal/PortalFooter";
import { LRDeliveryDocs, LRDeliveryFields } from "./AddFTLCNDeliveryConfig";
import { handleFormReset, updateSingleField, updateValueForm } from "../../FormInputSectionComponent/formUtils";
import { FormInputSectionComponent } from "../../FormInputSectionComponent/FormInputSectionComponent";
import { replaceUnderscore } from "../../../../CommonFunction/common";

const AddFTLCNDelivery = ({ fielddata, show, id, TypeOfPortal, submitType, ParentPortalCloseFunction }) => {
  const modifiedTypeOfPortal = useConcatenatedString(TypeOfPortal, "FTL CN Delivery");
  const [toggle, settoggle] = useState(show ? show : false);
  const { pushModal, popModal, getTopModal } = useModalContext();
  const formRef = useRef({});
  const [FormData, setFormdata] = useState({});
  // const [allFieldsData, setAllFieldsData] = useState(
  //   modifiedTypeOfPortal === "Add LR Delivery" || TypeOfPortal === "Add" ? { Date: GetTodaysDateINdmy() } : fielddata
  // );
  const Form_Key = "FTL_CN_Delivery";
  const [InputFields, setInputFields] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const [DocumentsFields, setDocumentsFields] = useState([]);
  const fielddataRedux = useSelector((store: any) => store.UniqueTableReducer.FTL_CN_Delivery);
  const selectedRow = fielddataRedux?.Selected_Row?._id;
  const [notedata, setNotesdata] = useState(fielddata ? fielddata.Narration : "");
  const [CreateLRDelivery, { loading: EditLoading, error, data }] = useMutation(CREATE_LR_DELIVERY, {
    onCompleted: () => {
      // after sucessfull add need to clear the data
      handleFormReset(formRef);
      setIssueDescription("");
      setNotesdata("");
      ClearSpecificForm(dispatch, Form_Key);
    },
  });
  const [EditLRDelivery, { loading: getLoading }] = useMutation(EDIT_FTL_CN_DELIVERY);
  const [formdata, setformdata] = useState(data ? data.GetLoadsOnRequestedData : []);

  const FormDataFromRedux = useSelector((store: any) => store.FormDataReducer);
  const dispatch = useDispatch();
  const [issueDescription, setIssueDescription] = useState("");
  // Add Meterial
  const [GetLRDeliveryById, { loading: AddLoading }] = useLazyQuery(GET_LRDelivery_BY_ID, {
    fetchPolicy: "network-only",
  });

  const [getFormSectionAndFields, { loading: getFormSectionAndFieldsLoading }] = useLazyQuery(
    getFormSectionsAndFields,
    {
      variables: {
        key: Form_Key,
      },
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        console.log(data);
        let CNFieldData = data?.formSectionAndFields.filter((e) => e.name === "LR_Delivery_Details");
        let DocumentsField = data?.formSectionAndFields.filter((e) => e.name === "Documents");
        setInputFields(CNFieldData);
        setDocumentsFields(DocumentsField)
      },
    }
  );


  const LoadingState = AddLoading || getLoading || EditLoading ? true : false;


  useEffect(() => {
    if (TypeOfPortal !== "Delete") {

      getFormSectionAndFields();
    }
  }, []);


  useEffect(() => {
    pushModal(Form_Key);
    return () => {
      popModal(Form_Key);
    };
  }, []);

  const HanldeChangeonForm = (values) => {
    setFormdata((prev) => ({
      ...prev,
      ...values,
    }));
  };

  const handleErrorsChange = (newErrors) => {
    setFormErrors((currentErrors) => ({
      ...currentErrors,
      ...newErrors,
    }));
  };

  useEffect(() => {
    if (InputFields.length) {
      if (TypeOfPortal !== "Add" && TypeOfPortal !== "Delete") {
        GetLRDeliveryById({
          variables: {
            id: selectedRow,
          },
        }).then(({ data }) => {
          let MemoData = { ...data?.getFTL_CNDeliveryByIdWithLR[0] };
          setIssueDescription(MemoData?.Issue_Description);
          setNotesdata(MemoData?.Note);
          // MemoData
          MemoData.Date = IsoToDateWithoutTime(MemoData?.Date);
          MemoData.LoadReceiptsId = MemoData?.LoadReceiptsData?.Search_Value;
          dispatch({
            type: "StoreMasterData",
            payload: {
              formkey: Form_Key,
              data: {
                LoadReceiptsId: MemoData?.LoadReceiptsData,
                Branch_Code: MemoData?.Branch_Code_Data,
              },
            },
          });
          updateValueForm(formRef, MemoData);
        });
      } else {
        updateSingleField(formRef, "Date", GetTodaysDateINdmy());
      }
    }
  }, [fielddata, InputFields]);

  //function to perform CRUD Opetationf
  const submit = async (close) => {
    let data: any = {
      ...FormData,
      Note: notedata,
      Issue_Description: issueDescription,
      Date: convertToISO(FormData.Date),
    };

    data.LoadReceiptsId = FormDataFromRedux?.MasterData[Form_Key]?.LoadReceiptsId?._id;

    if (TypeOfPortal === "Edit") {
      await EditLRDelivery({
        variables: {
          id: selectedRow,
          userInput: data,
        },
      })
        .then((res) => {
          dispatch({ type: "Refetch", payload: true });
          SuccessToast("LR Delivery Edited Successfully");
          Closeformfunction();
        })
        .catch((err) => {
          settoggle(toggle);
          ErrorToast("Something went wrong! Please Check fields and try again.");
        });
    } else {
      await CreateLRDelivery({
        variables: {
          createInput: data,
        },
      })
        .then((res) => {
          dispatch({ type: "Refetch", payload: true });
          SuccessToast("FTL CN Delivery Created Successfully");
          if (close === "close") {
            Closeformfunction();
          }
        })
        .catch((err) => {
          settoggle(toggle);
          ErrorToast("Something went wrong! Please Check fields and try again.");
        });
    }
    if (error) {
      ErrorToast(error.message);
    }
  };

  const Closeformfunction = () => {
    handleFormReset(formRef);
    ClearSpecificForm(dispatch, Form_Key);
    ParentPortalCloseFunction();
    settoggle(false);
  };




  return (
    <>
      <Reactportal
        open={toggle}
        onClose={Closeformfunction}
        TypeOfPortal={modifiedTypeOfPortal}
        //id={allFieldsData && allFieldsData?.id ? allFieldsData.id : id}
        ShowBranchInput={true}
        Form_Key={Form_Key}
      >
        {LoadingState && <div className="loader-line-div" />}
        <div className="LRDelivery">
          <div className="horizontalcontainer">
            {InputFields &&
              InputFields.map((e) => {
                return (
                  <div key={e.id} className="">
                    <div className="sectionHeadings">{replaceUnderscore(e.name)}</div>
                    <div className="horizantalSection insidecontainer">
                      <FormInputSectionComponent
                        inputfields={e.fields}
                        Type={e.name}
                        onhandleFormikChange={HanldeChangeonForm}
                        validation_Schema={e?.Valid_schema}
                        onErrorsChange={(newErrors) => handleErrorsChange(newErrors)}
                        formkey={Form_Key}
                        formRef={formRef}
                      />
                    </div>
                  </div>
                );
              })}
          </div>
          <div className="secondsection">
            <div className="LRDeliveryNotes">
              <div>
                <p className="NoteLable">Notes: </p>
              </div>
              <div className="moredetailsection">
                <textarea name="note" value={notedata} onChange={(e) => setNotesdata(e.target.value)}></textarea>
              </div>
            </div>
            <div className="LRDeliveryNotes">
              <div>
                <p className="NoteLable">Issue Description: </p>
              </div>
              <div className="moredetailsection">
                <textarea
                  name="note"
                  value={issueDescription}
                  onChange={(e) => setIssueDescription(e.target.value)}
                ></textarea>
              </div>
            </div>
            <div className="LRDeliveryDocument">
              <div className="">
                {DocumentsFields?.length > 0 &&
                  DocumentsFields.map((e) => {
                    return (
                      <div key={e.id} className="">
                        <div className="sectionHeadings">{replaceUnderscore(e.name)}</div>
                        <div className="horizantalSection insidecontainer">
                          <FormInputSectionComponent
                            inputfields={e.fields}
                            Type={e.name}
                            onhandleFormikChange={HanldeChangeonForm}
                            validation_Schema={e?.Valid_schema}
                            onErrorsChange={(newErrors) => handleErrorsChange(newErrors)}
                            formkey={Form_Key}
                            TypeOfPortal={TypeOfPortal}
                            formRef={formRef}
                          />
                        </div>
                      </div>
                    );
                  })
                }
              </div>
            </div>
          </div>
        </div>

        <PortalFooter
          renderContent={() => <></>}
          disabled={false}
          submitform={submit}
          submitType={submitType}
          SaveAndClose={() => {
            submit("close");
          }}
          handleformclose={() => {
            Closeformfunction();
            settoggle(!toggle);
          }}
          loadingState={LoadingState}
        />
      </Reactportal>
    </>
  );
};

export default AddFTLCNDelivery;
